import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'

export function EBorrowSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      {/* Filter bar skeleton */}
      <div className="flex items-center justify-between gap-4">
        {/* Desktop: category pills */}
        <div className="hidden flex-wrap gap-2 sm:flex">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-8 w-20 rounded-full" />
          ))}
        </div>
        {/* Mobile: single filter dropdown */}
        <div className="sm:hidden">
          <Skeleton className="h-8 w-20 rounded-full" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-9 rounded-lg" />
          <Skeleton className="h-9 w-16 rounded-lg" />
        </div>
      </div>

      {/* Desktop: List rows skeleton */}
      <div className="hidden flex-col rounded-xl border border-white/10 bg-panel md:flex">
        {/* Header row */}
        <div className="flex items-center justify-between rounded-t-xl border-white/5 border-b bg-card px-4 py-3">
          <Skeleton className="h-3 w-10" />
          <div className="flex items-center gap-8">
            <Skeleton className="h-3 w-12" />
            <Skeleton className="h-3 w-8" />
            <Skeleton className="h-3 w-14" />
            <Skeleton className="h-3 w-8" />
          </div>
        </div>
        {/* Rows */}
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="flex items-center justify-between border-white/5 border-b px-4 py-4 last:border-b-0">
            {/* Pair info: two overlapping token icons + curator badge */}
            <div className="flex items-center gap-3">
              <div className="relative shrink-0">
                <div className="-space-x-2 flex">
                  <Skeleton className="h-8 w-8 rounded-full ring-2 ring-background" />
                  <Skeleton className="h-8 w-8 rounded-full ring-2 ring-background" />
                </div>
              </div>
              <div className="flex flex-col gap-1">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-3 w-20" />
              </div>
            </div>

            {/* LTV, APY, Liquidity, Utilization, Arrow */}
            <div className="flex items-center gap-8">
              <div className="flex flex-col items-end gap-0.5">
                <Skeleton className="h-4 w-10" />
                <Skeleton className="h-3 w-12" />
              </div>
              <Skeleton className="h-4 w-12" />
              <Skeleton className="h-4 w-14" />
              <Skeleton className="h-4 w-10" />
              <Skeleton className="h-8 w-8 rounded-full" />
            </div>
          </div>
        ))}
      </div>

      {/* Mobile: Card skeleton */}
      <div className="mx-auto flex w-full max-w-lg flex-col gap-3 md:hidden">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="rounded-xl border border-white/[0.08] bg-white/[0.02] p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="relative shrink-0">
                  <div className="-space-x-2 flex">
                    <Skeleton className="h-8 w-8 rounded-full ring-2 ring-background" />
                    <Skeleton className="h-8 w-8 rounded-full ring-2 ring-background" />
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-3 w-20" />
                </div>
              </div>
              <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
            </div>
            <div className="mt-2 flex flex-col gap-2 border-white/[0.04] border-t pt-3">
              <div className="flex items-center justify-between">
                <Skeleton className="h-3 w-8" />
                <Skeleton className="h-4 w-14" />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton className="h-3 w-8" />
                <Skeleton className="h-4 w-16" />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton className="h-3 w-14" />
                <Skeleton className="h-4 w-14" />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton className="h-3 w-8" />
                <Skeleton className="h-4 w-10" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
